import DashboardIcon from '@mui/icons-material/Dashboard';
import { styled } from '@mui/material';
import type { IconProps } from '@mui/material/Icon';

import { goPalette } from '../../tsGoThemeVars';

export const StyledIcon = styled(DashboardIcon)<IconProps>(() => ({
	'&.expanded, &.collapsed': {
		color: goPalette.tsGoColor.grayDark,
		position: 'relative',
	},
	'&:hover, &.active-icon': {
		color: goPalette.tsGoColor.white,
	},
}));
